"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyAttributeItem = void 0;
var strategy_attribute_item_component_1 = require("./strategy-attribute-item.component");
Object.defineProperty(exports, "StrategyAttributeItem", { enumerable: true, get: function () { return strategy_attribute_item_component_1.StrategyAttributeItem; } });
